import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const HorseAndHound: Site = {
  id: 'horseandhound',
  logo: 'svg/horseandhound.svg',
  label: 'Horse & Hound',
  analyticsName: 'horseandhound',
  hostname: 'horseandhound.co.uk',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
